<section>
    <section class="payment-wrapper">
        <div class="container">
            <div class="pc-details d-flex justify-content-between flex-wrap">
                <div class="payment-details hideOnMobile">
                    <img src="assets/images/stepper-banner.jpg" alt="image" />
                </div>
                <div class="payment-banner plan-pricedetails">
                    <div class="subs-details">
                        <h2 class="servey-title show">
                            Coach Signup
                        </h2>
                        <h2 class="servey-title show" style="font-size: 2.2rem;">
                            14-Day Free Trial
                        </h2>
                        
                        <div class="offers">
                            <a href="javascript:void(0)" class="btn login-btn strted-btn" [class.dur-class]="true" (click)="getDurationType('monthly')">
                                <i [class.true-icon]="durationType == 'monthly'"></i>
                                <span>
                                    Monthly <br> $25/mo
                                </span>
                            </a>
                            <a href="javascript:void(0)" class="btn login-btn strted-btn" [class.dur-class]="true" (click)="getDurationType('yearly')">
                                <i [class.true-icon]="durationType == 'yearly'"></i>
                                <span>
                                    Annual<br> $180/yr
                                </span>
                            </a>
                        </div>
                        <ul class="list-details">
                            <!-- <li _ngcontent-serverapp-c108=""><span _ngcontent-serverapp-c108="" class="tick-red"><img _ngcontent-serverapp-c108="" src="assets/images/tick-red.png" alt=""></span> Signup by Jan 31 at $120/yr ($180/yr from Feb 2024) </li> -->
                            <li _ngcontent-serverapp-c108=""><span _ngcontent-serverapp-c108="" class="tick-red"><img _ngcontent-serverapp-c108="" src="assets/images/tick-red.png" alt=""></span> Listing in the coach's directory </li>
                            <li _ngcontent-serverapp-c108=""><span _ngcontent-serverapp-c108="" class="tick-red"><img _ngcontent-serverapp-c108="" src="assets/images/tick-red.png" alt=""></span> One personalized webpage with full bio and all product listings. </li>
                            <li _ngcontent-serverapp-c108=""><span _ngcontent-serverapp-c108="" class="tick-red"><img _ngcontent-serverapp-c108="" src="assets/images/tick-red.png" alt=""></span> Upload up to 5 paid courses </li>
                            <li _ngcontent-serverapp-c108=""><span _ngcontent-serverapp-c108="" class="tick-red"><img _ngcontent-serverapp-c108="" src="assets/images/tick-red.png" alt=""></span> Upload up to 5 personal training and coaching packages</li>
                            <li _ngcontent-serverapp-c108=""><span _ngcontent-serverapp-c108="" class="tick-red"><img _ngcontent-serverapp-c108="" src="assets/images/tick-red.png" alt=""></span> Upload up to 5 wellness retreats </li>
                            <!-- <li _ngcontent-serverapp-c108=""><span _ngcontent-serverapp-c108="" class="tick-red"><img _ngcontent-serverapp-c108="" src="assets/images/tick-red.png" alt=""></span> Upload unlimited wellness products </li> -->
                            <li _ngcontent-serverapp-c108=""><span _ngcontent-serverapp-c108="" class="tick-red"><img _ngcontent-serverapp-c108="" src="assets/images/tick-red.png" alt=""></span> Automated dashboard for tracking total sales and profile views</li>
                            <li _ngcontent-serverapp-c108=""><span _ngcontent-serverapp-c108="" class="tick-red"><img _ngcontent-serverapp-c108="" src="assets/images/tick-red.png" alt=""></span> Community building & cross selling features </li>
                            <li _ngcontent-serverapp-c108=""><span _ngcontent-serverapp-c108="" class="tick-red"><img _ngcontent-serverapp-c108="" src="assets/images/tick-red.png" alt=""></span> Integrated payment system</li>
                        </ul>
                    </div>

                    <div class="subsform">
                        <h2 class="servey-title form-title">
                            It's nice to meet you! Let's get started.
                        </h2>
                        <p>
                            Tell us a bit about yourself to activate your
                            <span>
                                14-Day Free Trial.
                            </span>
                        </p>
                        <span class="invalid-feedback">{{message}}</span>
                        <form id="lead-create-account" [formGroup]="venderForm">
                           
                            <div class="form-group">
                                <input type="text" formControlName="firstName" class="form-control" placeholder="First Name*"
                                    onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>
                                <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                    <div *ngIf="f.firstName.errors.required">First Name is required</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <input type="text" formControlName="lastName" class="form-control" placeholder="Last Name*"
                                    onkeypress='return (event.which > 64 && event.which < 91) || (event.which > 96 && event.which < 123) || event.which == 8 || event.which == 46'>
                                <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                    <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <input type="text" formControlName="email" class="form-control"
                                    placeholder="Email Address*">
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <div *ngIf="f.email.errors.required">Email is required</div>
                                    <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <input type="password" formControlName="password" class="form-control" autocomplete
                                    placeholder="Password*">
                                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                    <div *ngIf="f.password.errors.required">Password is required</div>
                                    <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                                    <div *ngIf="f.password.errors.maxlength">Password must be at most 10 characters</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <input type="password" formControlName="confirmPassword" class="form-control"
                                    autocomplete placeholder="Confirm Password*">
                                <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                                    <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required</div>
                                </div>
                                <div *ngIf="submitted && cPassword" class="invalid-feedback">Passwords must match</div>
                            </div>
                            <a href="javascript:void(0)" class="btn login-btn strted-btn" (click)="submitForm()">
                                <span>
                                    submit
                                </span>
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>